import React from 'react';

const ValentinesDecorations = () => {
  // Generate floating hearts
  const hearts = Array.from({ length: 25 }, (_, i) => ({
    id: i,
    left: Math.random() * 100,
    delay: Math.random() * 10,
    duration: 8 + Math.random() * 6,
    size: 12 + Math.random() * 20,
    opacity: 0.3 + Math.random() * 0.4,
  }));

  return (
    <div className="fixed inset-0 pointer-events-none z-40 overflow-hidden">
      {hearts.map((heart) => (
        <div
          key={`heart-${heart.id}`}
          className="absolute animate-float-heart"
          style={{
            left: `${heart.left}%`,
            bottom: '-40px',
            fontSize: `${heart.size}px`,
            opacity: heart.opacity,
            animationDelay: `${heart.delay}s`,
            animationDuration: `${heart.duration}s`,
            color: heart.id % 3 === 0 ? '#FF69B4' : heart.id % 3 === 1 ? '#FF1493' : '#DC143C',
            textShadow: '0 0 10px currentColor',
          }}
        >
          ❤️
        </div>
      ))}

      {/* Subtle pink gradient overlay at edges */}
      <div className="absolute top-0 left-0 w-32 h-full bg-gradient-to-r from-pink-500/10 to-transparent" />
      <div className="absolute top-0 right-0 w-32 h-full bg-gradient-to-l from-pink-500/10 to-transparent" />
    </div>
  );
};

export default ValentinesDecorations;
